  
export const exctractDataFromFiles = async (files) => {
  try {
    const resultArray = [];

    // Use Promise.all to wait for all promises to resolve
    await Promise.all(files.map(async (file) => {
      const fileContent = await readFile(file);
      const lines = fileContent.split('\n');

      // Find the start and end indices of the chromatogram data
      const startIndex = lines.findIndex(line => line.startsWith('Time (min)')) + 1;
      const endIndex = lines.length;

      // Extract the relevant data from the chromatogram section
      const chromatogramData = lines.slice(startIndex, endIndex).map(line => line.split('\t')).filter(data => data.length >= 3);

      // Create an array of objects with x and y values
      const fileName = file.name;
      const fileResult = {
        name: fileName,
        originalData: chromatogramData.map(data => ({ x: parseFloat(data[0]), y: parseFloat(data[2]) })),
      };

      resultArray.push(fileResult);
    }));

    // setData(resultArray.flat()); // Use flat to flatten the array of arrays
    return resultArray;

  } catch (error) {
    console.error('Error reading or parsing files:', error);
    throw error; // Re-throw the error to be caught by the calling code
  }
};

const readFile = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      resolve(event.target.result);
    };

    reader.onerror = (error) => {
      reject(error);
    };

    reader.readAsText(file);
  });
};
